import {Typography} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import PlayerSessionsList from './PlayerSessionsList';
import FullScreenLoadingSpinner from './FullScreenLoading';
import {Baseline, PlayerSession} from '../../interfaces';

interface Props {
  navigateUrlPrefix: string;
  groupNavigateUrlPrefix?: string;
  playerSessions: PlayerSession[];
  baselines?: Baseline[];
  loading?: boolean;
}

/**
 * The list / loading / empty tri-state shared by the Player Sessions page and
 * the Player Dashboard sessions tab.
 */
const PlayerSessionsPanel: React.FC<Props> = ({
  navigateUrlPrefix,
  groupNavigateUrlPrefix,
  playerSessions,
  baselines,
  loading,
}) => {
  const {t} = useTranslation();

  if (playerSessions.length > 0) {
    return (
      <PlayerSessionsList
        navigateUrlPrefix={navigateUrlPrefix}
        groupNavigateUrlPrefix={groupNavigateUrlPrefix}
        playerSessions={playerSessions}
        baselines={baselines}
        showDate={true}
      />
    );
  }

  if (loading) {
    return <FullScreenLoadingSpinner />;
  }

  return (
    <Typography variant="h3" sx={{textAlign: 'center'}}>
      {t('sessionFilter.noSessions')}
    </Typography>
  );
};

export default PlayerSessionsPanel;
